import api from '../api';
import { GetOrganizationResponse } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useGetOrganization = () => {
  const organization = ref<GetOrganizationResponse | null>(null);
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);
  const loadOrganization = async (organizationUid: string): Promise<GetOrganizationResponse | null> => {
    try {
      isLoading.value = true;
      const response = await api.organization.get(organizationUid);
      organization.value = response.data;
    } catch (err: unknown) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

    return organization.value;
  };

  return {
    loadOrganization,
    isLoading,
    organization,
    error,
  };
};
